import useSWR from 'swr';
import { DeepNullable } from 'ts-essentials';

import fetcher from 'lib/fetcher';
import { APIApartmentRoomType, CoordinatesSchema, MarketTypes } from 'api/types';
import { ApartmentFilters } from './use-aparments-filter-query';
import { TSellerType } from '../../lib/types';
import { IPolygonItemRequest } from './use-apartments-limits-secondary';

export type PlansItemType = {
  areaInSqM: number;
  id: number;
  media: { id: number; mimeType: string; name: string; url: string | null };
  selected: boolean | null;
};

export type APIApartmentFilterLimitsRes = {
  count: number;
  filters: DeepNullable<{
    areaMax: number;
    areaMin: number;
    priceMax: number;
    priceMin: number;
    pricePerSqMMax: number;
    pricePerSqMMin: number;
    marketPriceMax: number;
    marketPriceMin: number;
    floorMin: number;
    floorMax: number;
    floorCountMin: number;
    floorCountMax: number;
    commissioningYearMin: number;
    commissioningYearMax: number;
    marketType?: MarketTypes;
    plans: PlansItemType[];
    polygons: IPolygonItemRequest[];
    sellerTypes: TSellerType[];
    buildingAddressSearchPoligons?: CoordinatesSchema[][] | null;
  }> & { facilityTypes: APIApartmentRoomType[] };
};

const useApartmentsFilterLimits = (filter?: ApartmentFilters | null, fetch = true) => {
  const { data, error, isLoading, isValidating } = useSWR(fetch ? [filter] : null, ([filter]) =>
    fetcher
      .swr<APIApartmentFilterLimitsRes>('/facilities/filter-limits', {
        method: 'post',
        data: { filter },
      })
      .then((res) => {
        const facilityTypes = res.filters.facilityTypes;

        return { ...res, filters: { ...res.filters, facilityTypes } };
      }),
  );

  return {
    filterLimits: data?.filters,
    count: data?.count,
    error,
    isLoading: isLoading || isValidating,
  };
};

export default useApartmentsFilterLimits;
